import {useContext} from "react";
import {AuthContextType} from "../models/interfaces/auth-context-type.interface";
import {AuthContext} from "../contexts/auth-context";

const useAuth = () => {
    const context: AuthContextType = useContext(AuthContext);

    if (!context) {
        throw new Error("useAuth must be used within and AuthProvider");
    }
    return context;
}

export default useAuth
